module.exports = __webpack_public_path__ + "img/1728543680866-Screenshot_10-10-2024_15058_web.whatsapp.com.jpeg.19654e0a.webp";